﻿import {Core} from "../Base/Core";
import EventEmitter from "eventemitter3";

export class CreatureController extends EventEmitter {
    creatureId = 0;
    creatureData; // CreatureData
    epoch; // EpochController

    Init(creatureId, epoch) {
        this.creatureId = creatureId;
        this.epoch = epoch;
        this.creatureData = Core.GameData.Creatures.Get(creatureId);
    }

    RemoveCreature() {
        this.epoch.RemoveCreature(this);
        this.emit("CreatureRemoved");
    }
}
